import React, { useState } from 'react';
import {Link} from "react-router-dom"
function TermsCheckboxComponent() {
  const [agreed, setAgreed] = useState(false);

  const handleChange = (e) => {
    setAgreed(e.target.checked);
  };

  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <input
        type="checkbox"
        checked={agreed}
        onChange={handleChange}
        required
      />
      <span className='text-gray-300'>
        I agree to the{' '}
        <Link className='text-blue-300 ' to="/terms"  rel="noopener noreferrer">
          Terms and Conditions
        </Link>
      </span>
    </label>
  );
}

export default TermsCheckboxComponent;
